import * as sites from 'goodeggs-sites';
import NamedError from 'goodeggs-named-error';

export default __filename;
angular.module(__filename, []).factory(
  'PurchasingUom',
  ngInject(function($http, $q, settings) {
    return {
      getPurchasingUomsByIds(ids) {
        const results = $q.defer();
        let after = null;
        const purchasingUoms = [];
        function getPagesRecursively() {
          $http({
            method: 'POST',
            url: `${sites.getUrl('catalog-api', settings)}/graph`,
            data: {
              operationName: 'getPurchasingUomsByIds',
              variables: {ids, after},
              query: `\
                    query getPurchasingUomsByIds($ids: [ID!]!, $after: String) {
                      purchasingUoms (ids: $ids, after: $after) {
                        pageInfo {
                          hasNextPage
                          endCursor
                        }
                        edges {
                          node {
                            id
                            riversandId
                          }
                        }
                      }
                    }\
                    `,
            },
          }).then((result) => {
            const graphQLResponse = result.data;
            if (
              graphQLResponse.data == null ||
              graphQLResponse.data.purchasingUoms == null ||
              graphQLResponse.data.purchasingUoms.edges == null
            ) {
              throw new NamedError({
                message: 'Unexpected response from Catalog API for getPurchasingUomsByIds query',
                data: {result},
              });
            }
            const purchasingUomData = graphQLResponse.data.purchasingUoms;
            const {edges, pageInfo} = purchasingUomData;
            purchasingUoms.push(...edges.map(({node}) => node));
            if (pageInfo.hasNextPage) {
              after = pageInfo.endCursor;
              getPagesRecursively();
            } else {
              results.resolve(purchasingUoms);
            }
          });
        }

        getPagesRecursively();
        return results.promise;
      },
    };
  }),
);
